// extracted by mini-css-extract-plugin
export default {"statistic":"styles_statistic__+IR-W","statistic__icon-value":"styles_statistic__icon-value__JriUz","statistic-bar":"styles_statistic-bar__2j4+1"};